<template>
	<div>
	<div class="promotion-campaign-filters promotion-table-filters ad-d-flex ad-d-flex-between" v-if="ad_obj.id">
			  <div class="promotion-table-filters-left-part ad-d-flex ad-d-flex-start" >
			     <div class="ad-d-flex">				    
					<el-tag type="info" @close="allCreative" v-if="ad_obj.id" closable>已选计划:{{ad_obj.name}}</el-tag>
				 </div>
			  </div>
			</div>
		   <el-table :data="list" border highlight-current-row v-loading="listLoading"  @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column fixed label="创意ID" align="center" width="160">
				<template slot-scope="scope">
					{{scope.row.creative_id}}				
				</template>
			</el-table-column>	
			<el-table-column fixed label="素材类型" align="center" width="100">
				<template slot-scope="scope">
					{{scope.row.image_mode_name}}				
				</template>
			</el-table-column>			
			<el-table-column  fixed label="广告创意" align="left" width="300">
			  <template slot-scope="scope">
			    <el-popover
				  placement="right"
				  width="400"
				  trigger="hover">
				  <el-row>
					<div @click="preview(scope.row)" class="image-background"><img :src="scope.row.image_url" /></div>
				  </el-row>
				  <div slot="reference" @click="preview(scope.row)" class="image-content" style="width: 80px; height: 45px;padding:5px 5px;">
				  <img :src="scope.row.image_url" class="image-preview">
				  <img src="//s1.pstatp.com/bytecom/platform_web/static/image/play.svg?f3db861d10cf31d0ff0778b1b4331ba9" class="video-player">
				</div>
				</el-popover>
				
				<div class="creative-title multiple-line-txt-cut">{{scope.row.title}}</div>
			  </template>
			</el-table-column>
			<el-table-column label="广告创意状态" align="center" width="130">
			 <template slot-scope="scope">
			  <span v-if="scope.row.status=='CREATIVE_STATUS_DELIVERY_OK'"><i style="color:#4dd599;font-size:7px;margin-right:2px;" class="fa fa-circle"></i> {{scope.row.statusName}}</span>
			  <span v-else ><i style="color:#999;font-size:7px;margin-right:2px;" class="fa fa-circle"></i> {{scope.row.statusName}}</span>
			 </template>
			</el-table-column>			
			<el-table-column prop="report.cost" label="消耗(元)" sortable align="center" width="100">
			</el-table-column>			
			<el-table-column prop="report.show" sortable label="展示" width="100" align="center"></el-table-column>
			<el-table-column prop="report.click" sortable label="点击" width="100" align="center"></el-table-column>
			<el-table-column prop="report.convert" sortable label="转化数" width="100" align="center"></el-table-column>
			<el-table-column prop="report.cpi" sortable label="CPI" width="100" align="center"></el-table-column>
			<el-table-column prop="report.cpm" sortable label="CPM" width="100" align="center"></el-table-column>
			<el-table-column prop="report.ctr" sortable  label="CTR(%)" width="100" align="center"></el-table-column>
			<el-table-column prop="report.cvr" sortable label="CVR(%)" width="100" align="center"></el-table-column>
			<el-table-column label="所属广告计划" align="center" width="300">
			  <template slot-scope="scope">
				<el-link style="font-size:12px;" type="primary">{{scope.row.report.ad_name}}</el-link>
			 </template>
			</el-table-column>
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-button type="success" @click="updateStatus('enable')" :disabled="this.sels.length===0" icon="el-icon-check" size="small">开启</el-button>
			<el-button type="warning" @click="updateStatus('disable')" icon="el-icon-video-pause" :disabled="this.sels.length===0" size="small">暂停</el-button>
			<el-pagination layout="total,sizes,prev, pager, next" @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-size="pagesize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		</div>
</template>

<script>
	import { getCreativeListPage,previewVideo,updateAdStatus } from '../../../api/api';
	
	export default {
		props:{
		  PannelName: {
            type: String,
			default:''
		  },
		  ad_obj:{
		   type: Object,
			default:{}
		  }
		},
		data() {
			return {
				sels:[],
				total:0,
				page:1,
				pagesize:10,
				listLoading:false,
				list:[],
			}
		},
		watch:{
		  PannelName:{
			 handler(val, oldVal){
			   if( val=='CreativePanel' )
			   {
			     this.getCreative()
			   }
			 },
			 deep:true
		 }
		},
		computed:{
		   advertiser_id(){
		     return this.$store.getters.getAdvertiserId
		   },
		   filtering(){
		     return this.$store.getters.getFiltering
		   }
		},
		methods: {
		   handleCurrentChange(val){
			  this.page = val
			  this.getCreative()
			},
			preview(row){
			   let params ={
			      advertiser_id:row.advertiser_id,
				  video_id:row.video_id,
				  type:1
			   }
			   previewVideo(params).then((res) => {
					window.open(res.data.url)
					
				});
			},
			handleSizeChange(val) {
			  this.pagesize = val
			  this.page = 1
			  this.getCreative()
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			allCreative(){
			  this.$emit("updateData")
			  this.getCreative(1)
			},
			updateStatus(status){
			  let ids = this.sels.map((item, i, arr) => {					
					return item.creative_id
				})
			  let para = {
					type: 1,
					level:'creative',
					advertiser_id: this.advertiser_id,
					status:status,
					ids:ids
				};
                updateAdStatus(para).then((res) => {
					this.$message.success('操作成功');									  
					  this.page=1
					  this.sels =[]
					  this.getCreative()						
				});				
			},
			getCreative(id=0){
			  
			  let para = {
					page: this.page,
					advertiser_id: this.advertiser_id,
					ad_id:id==1?0:this.ad_obj.id,
					filtering:this.filtering,
					page_size:this.pagesize
				};
				this.listLoading = true;
				getCreativeListPage(para).then((res) => {
					this.total = res.data.page_info.total_number;
					this.list = res.data.list;
					this.listLoading = false;
				});
			}
		},
		mounted() {	
		}
	}

</script>
<style  lang="scss">
  .image-content img{width:100%;height:100%;}
  .image-content {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
	cursor:pointer;
}
.image-background img {
    vertical-align: middle; 
    //filter: blur(1.5px);
}
.image-background img {
   
	 max-height:400px;
    width: 100%;   
}
.image-background{
    max-height:400px;
	width:100%;
	cursor:pointer;
}
.creative-title {
     line-height: 20px;
     margin-left: 80px;
}
  .left-area .image-content .image-preview{
    max-width: 100%;
    max-height: 100%;
    vertical-align: bottom;
}
  .image-content .video-player{
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}
</style>


// WEBPACK FOOTER //
// creative.vue?51ba1ae7